export enum UploadType {
  Unspecified = 0,
  Report = 1,
  FileUpload = 2,
}
